import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import SheetAnimationNameEnum from '../../enums/SheetAnimationNameEnum.js';
import SheetStateEnum from '../../enums/SheetStateEnum.js';
import SheetBackdropStyle from './SheetBackdropStyle.js';
/**
 * SheetBackdrop component class.
 */

export default class SheetBackdrop extends KompisElement {
	// If it should be visible. Opens and closes with transitions
	@property({ type: Boolean })
	public visible = false;

	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	private state = SheetStateEnum.closed;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		return html`
			<style>
				${SheetBackdropStyle.getStyle({
					state: this.state,
					theme: this.theme
				})}
			</style>
			<div class="container" @animationend="${this.onAnimationEnd.bind(this)}"></div>
		`;
	}

	protected override shouldUpdate(
		changedProperties: Map<string, object | number | string | boolean>
	): boolean {
		if (changedProperties.has('visible')) {
			if (this.visible) {
				this.state = SheetStateEnum.opening;
			} else {
				this.state = SheetStateEnum.closing;
			}
		}

		return true;
	}

	/**
	 * Listener for animationend.
	 *
	 * @param event Html event.
	 */
	private onAnimationEnd(event: AnimationEvent): void {
		event.stopPropagation();

		if (event.animationName.startsWith(SheetAnimationNameEnum.closing)) {
			this.state = SheetStateEnum.closed;
		} else if (event.animationName.startsWith(SheetAnimationNameEnum.opening)) {
			this.state = SheetStateEnum.open;
		}

		this.update();
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-sheet-backdrop': SheetBackdrop;
	}
}
